import i18n from "src/core/configs/i18n";

function ChangeLanguageButtonComponent() {
  const changeLanguage = (lng: string | undefined) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div className="flex text-base font-arRegular mobile:hidden">
      {i18n.language === "ar" ? (
        <div className="flex flex-row gap-2">
          <button
            className="text-zinc-600"
            onClick={() => changeLanguage("en")}
          >
            English
          </button>
          <div className="bg-[#E5E5E5] rounded-full w-[1px] h-8"></div>{" "}
          <button
            className="text-tart-500"
            onClick={() => changeLanguage("ar")}
          >
            العربية
          </button>
        </div>
      ) : (
        <div className="flex flex-row gap-2">
          <button
            className="text-tart-500"
            onClick={() => changeLanguage("en")}
          >
            English
          </button>
          <div className="bg-[#E5E5E5] rounded-full w-[1px] h-8"></div>{" "}
          <button
            className="text-zinc-600"
            onClick={() => changeLanguage("ar")}
          >
            العربية
          </button>
        </div>
      )}
    </div>
  );
}

export default ChangeLanguageButtonComponent;
